import { colorSet } from '@theme';
import { IThreeDImageListItem } from '@types';
import { SecureImage } from './SecureImage';

interface IProps {
  onClick: () => void;
  item: IThreeDImageListItem;
  itemSize: string;
}

export const ThreeDImageListItemComponent = (props: IProps) => {
  const { onClick, item, itemSize } = props;

  return (
    <div
      onClick={onClick}
      style={{ flex: `0 0 ${itemSize}`, width: itemSize, aspectRatio: 1, overflow: 'hidden', cursor: 'pointer' }}
    >
      <SecureImage
        imageUrl={item.previewImageUrl}
        imageStyle={{
          width: '100%', // 부모 div의 너비를 채우도록 설정
          height: '100%', // 부모 div의 높이를 채우도록 설정
          objectFit: 'cover', // 이미지 비율을 유지하면서 채우기
          borderRadius: '6px',
          border: `1px solid ${colorSet.gray300}`
        }}
      />
    </div>
  );
};
